export class VehicleIcon {
	
	class_name: string;
	value: string;
	capitalize?: boolean = true;
	
	constructor(vehicle_icon: VehicleIcon) {
		Object.assign(this, vehicle_icon);
	}
	
}
